import getDatasourceByType from './utils/getDatasourceByType';
import filters from '../filters';
import convertList from '../convertList';

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'ConfGroupMember',
            cancelConvertList: true
        })
            .then(list => {
                const filterList = filters.filterTroopList(list, selfConfig);
                resolve(
                    convertList(
                        filterList,
                        {
                            list: 'memberList',
                            groupName: 'name'
                        },
                        {
                            ...config,
                            // 对分组进行处理，如果是当前群组会打上标记，方便在群后面显示当前群逻辑
                            transformGroup(originItem) {
                                const item = originItem;
                                try {
                                    if (`${config.extendConfig.triggerInfo.id}` === `${item.id}`) {
                                        item.isCurrentGroup = true;
                                    }
                                } catch (err) {
                                    // no catch
                                }
                                return item;
                            },
                            transformItem(originItem) {
                                const item = originItem;
                                const extend = {
                                    groupType: 0
                                };
                                item.extend = Object.assign(item.extend || {}, extend);
                                return item;
                            }
                        }
                    )
                );
            })
            .catch(err => {
                reject(err);
            });
    });
}
